import React from 'react'
import ToggleButtonGroup from './ToggleButtonGroup'
import { Controller } from 'react-hook-form'

const ToggleButtonGroupController = ({
	control,
	name,
	toggleFieldLabel,
	toggleOption,
	styleMode,
	rules = {},
	disabledOptions = [],
	isNoticeNeed = false,
	isNoticeNeedText = '',
	isNoticePostion = 'top',
}) => {
	return (
		<Controller
			name={name}
			control={control}
			rules={rules}
			render={({ field }) => (
				<ToggleButtonGroup
					toggleFieldLabel={toggleFieldLabel}
					toggleFieldVariable={field.value}
					toggleOption={toggleOption}
					onChange={field.onChange}
					styleMode={styleMode}
					disabledOptions={disabledOptions}
					isNoticeNeed={isNoticeNeed}
					isNoticeNeedText={isNoticeNeedText}
					isNoticePostion={isNoticePostion}></ToggleButtonGroup>
			)}></Controller>
	)
}

export default ToggleButtonGroupController
